import {priority} from '@priority-software/priority-proto-api/lib';
import {showFormClientSideMessage} from '../../Form/actions/messages';
import {uploadImage} from '../services';
import {isBase64SizeGreaterThan0_5MB} from './checkHtmlSize';
import {getUt8Array} from './common';
import {texts} from '../texts';

export const imageHTMLProcess = async (htmlString: string) => {
    const parser = new DOMParser();

    const placeholderMap = {};
    let counter = 0;
    htmlString = htmlString.replace(/<<[^>]+>>/g, match => {
        const key = `__CUSTOM_TAG_${counter++}__`;
        placeholderMap[key] = match;
        return key;
    });

    const doc = parser.parseFromString(htmlString, 'text/html');

    const imgTags = doc.querySelectorAll('img');

    let tempHtml = htmlString;

    for (let i = 0; i < imgTags.length; i++) {
        const img = imgTags[i];
        const src = img.getAttribute('src');
        const alt = img.getAttribute('alt');
        if (
            src &&
            src.startsWith('data:image') &&
            src.includes('base64,') &&
            !src.match(/^(https?:\/\/|\/\/)/i)
        ) {
            const ext = getExtensionFromDataUrl(src);
            const name = alt ? alt : `image_${i + 1}`;

            if (isBase64SizeGreaterThan0_5MB(src)) {
                const content = texts.check_mail_weight_content.replace('<P1>', name);
                showFormClientSideMessage('', priority.netitems.shared.Message.Type.Error, {
                    title: texts.check_mail_weight_title,
                    content,
                    confirmButtonText: texts.check_mail_weight_btn
                });

                return {html: tempHtml, isOverSize: true};
            }

            const base64Data = src.split(',')[1];
            const fileName = `${name}.${ext}`;
            const data = getUt8Array(base64Data);
            const response = await uploadImage(fileName, data);

            if (response?.Url) {
                img.setAttribute('src', response.Url);
            }

            tempHtml = doc.body.innerHTML;
        }
    }

    let finalHTML = doc.body.innerHTML;
    for (const [key, value] of Object.entries(placeholderMap)) {
        finalHTML = finalHTML.replace(new RegExp(key, 'g'), value as string);
    }

    return {html: finalHTML, isOverSize: false};
};
function getExtensionFromDataUrl(dataUrl) {
    const regex = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
    const matches = dataUrl.match(regex);
    if (matches) {
        const mime = matches[1];
        return mime.split('/')[1];
    }

    return null;
}
